import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import type { TOrdersByType } from '../../interfaces/orders';
import type { IOrdersParams } from '../../services/orders';
import { getOrders } from '../../services/orders';

export interface IState {
  orders: TOrdersByType;
  isLoading: boolean;
  isLoaded: boolean;
}

const initialState: IState = {
  orders: null,
  isLoading: false,
  isLoaded: false,
};

export const fetchOrders = createAsyncThunk('orderService/fetchOrders', (params: IOrdersParams) => getOrders(params));

const orders = createSlice({
  name: 'orders',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchOrders.pending, (state) => {
      state.isLoading = true;
      state.isLoaded = false;
    });
    builder.addCase(fetchOrders.fulfilled, (state, { payload }) => {
      state.orders = payload;
      state.isLoading = false;
      state.isLoaded = true;
    });
    builder.addCase(fetchOrders.rejected, (state) => {
      state.isLoading = false;
      state.isLoaded = false;
    });
  },
});

const { reducer } = orders;

export default reducer;
